import React from "react";
import {
  AlignLeft, Check, Code, Hash, Image as ImageIcon, List, ListChecks, Type,
} from "lucide-react";
import { AppCard, AppCardContent, Radio } from "../../ui";

const ICONS = {
  // Not a circle: beside the radio a dot icon reads as a second radio.
  single_choice: List,
  multi_select: ListChecks,
  true_false: Check,
  text_answer: AlignLeft,
  fill_blank: Type,
  numeric_answer: Hash,
  image_mcq: ImageIcon,
  code_conceptual: Code,
};

function TypeLabel({ type }) {
  const Icon = ICONS[type.value] || List;
  return (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-font-semibold">
      <Icon size={16} aria-hidden="true" className="tw-text-primary" />
      {type.label}
    </span>
  );
}

/**
 * Step 2 — how students answer. One radio group across every card, so the
 * arrow keys move between types. Changing the type keeps the question; the
 * Answer step then asks only for what this type needs.
 */
export default function TypeStep({ value, types, onChange }) {
  return (
    <AppCard>
      <AppCardContent>
        <fieldset className="tw-m-0 tw-min-w-0 tw-border-0 tw-p-0">
          <legend className="tw-sr-only">Question type</legend>
          <div className="tw-grid tw-gap-3 min-[768px]:tw-grid-cols-2">
            {types.map((t) => (
              <Radio
                key={t.value}
                variant="card"
                name="question-type"
                value={t.value}
                checked={value === t.value}
                onChange={() => onChange(t.value)}
                label={<TypeLabel type={t} />}
                description={t.hint}
                className="tw-h-full"
              />
            ))}
          </div>
        </fieldset>
      </AppCardContent>
    </AppCard>
  );
}
